import * as React from 'react';
import { IItemCardProps, IAdminItemCardButtonsProps } from 'models/itemcard';
import * as moment from 'moment';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IMenuItem } from 'models/menuitem/menuitem';

import { AdminItemCardButtons } from 'components';

interface IProps extends IItemCardProps {
	item: IMenuItem;
	publishItem?: (itemId: string, languageKey: number) => void;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class AdminMenuItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.publishItem = this.publishItem.bind(this);
	}

	public editItem(e: any) {
		e.cancelBubble = true;
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		if (this.props.editItem !== undefined) {
			this.props.editItem(this.props.item.code);
		}
	}

	public deleteItem(e: any) {
		e.cancelBubble = true;
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		if (this.props.deleteItem !== undefined) {
			this.props.deleteItem('', this.props.item.id);
		}
	}

	public publishItem(e: any) {
		e.cancelBubble = true;
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		if (this.props.publishItem !== undefined) {
			this.props.publishItem(this.props.item.id, this.props.item.languageKey);
		}
	}

	public render() {
		const { title, addedDate, expireDate, published } = this.props.item;
		const { t, currentUserIsAdministrator } = this.props;

		const adminItemCardButtonsProps: IAdminItemCardButtonsProps = {
			editItem: null,
			deleteItem: this.props.deleteItem !== undefined && currentUserIsAdministrator ? this.deleteItem : null,
			copyItem: null,
			viewItem: null,
			settingsItem: null,
		};

		return (
			<div className="adminItemCard">
				<div className={`innerHolder ${published ? 'published' : null}`} onClick={this.editItem}>
					<div className="title">
						<div className={`${published ? 'publishedTitle' : 'notPublishedTitle'}`}>{title}</div>
					</div>
					<div className="published">{t(published ? 'BSPortal_Common_Yes' : 'BSPortal_Common_No')}</div>
					<div className="dateText created-date">
						<span>{moment(addedDate).format('L')}</span>
					</div>
					<div className="dateText expires-date">
						<span>{moment(expireDate).format('L')}</span>
					</div>
					<div className="control">
						<AdminItemCardButtons {...adminItemCardButtonsProps} />
					</div>
				</div>
			</div>
		);
	}
}

export { AdminMenuItemCard };
